<template>
    <el-select :value="value" @input="$emit('input',$event)"
               @change="$emit('change', $event)"
               placeholder="选择科室" :size="size" clearable>
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
</template>
<script>
    export default {
        name: "selectDepartment",
        props: {
            value: {
                type: [String, Number,]
            },
            hospital_id: {
                required: true
            },
            size: {
                default: 'small'
            }
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            hospital_id(newVal){
                this.getData()
            }
        },
        data() {
            return {
                options:[]
            }
        },
        methods: {
            async getData() {
                const resp = await this.$http.get(`/mingde/department/?hospital_id=${this.hospital_id}`)
                this.options = resp.data.data.data
            }
        },
        mounted() {
            this.getData()
        }
    };
</script>
<style lang="scss" scoped>
</style>
